import React, { useState, useEffect, useContext } from "react";
import Calendar from 'react-calendar';
import GlobalContext from "../context/GlobalContext";
import { HomeFeaturedList } from "../utils/GetAPIUtils";
import Header from "../components/Header/MinHeader";
import Footer from "../components/Footer/MinFooter";
import "../style/css/style.css";
import "../style/css/media.css";

import "../style/css/common.css";
import { useLocation } from 'react-router-dom';
export default function MainPage() {
    const gContext = useContext(GlobalContext);
    const [featuredData, setFeaturedData] = useState(null);
    const pathName = useLocation().pathname.toLowerCase();
    const imgM = "/images/syncuppro-logo.svg";
    const hide = true;
    async function getHomeFeatureData() {
        try {

            const result = await HomeFeaturedList();

            if (result.data.homeFeaturedList.responseData.code == "200") {

                let data = JSON.parse(result.data.homeFeaturedList.responseData.message);

                setFeaturedData(data);
            }

        }
        catch (e) {

        }
    }
    useEffect(() => {
        document.title = "Home | Syncuppro";
        const user = localStorage.getItem('connect');
        if (user == null && pathName.trim().toLowerCase() == "/login") {

            gContext.toggleSignInModal();
        }
        if (user == null && pathName.trim().toLowerCase() == "/signup") {
            gContext.toggleSignUpModal();
        }
        if (user == null && (pathName.trim().toLowerCase() == "/signupsuccess" || pathName.trim().toLowerCase() == "/signupsuccess_expert" || pathName.trim().toLowerCase() == "/signupsuccess_client") && localStorage.getItem('userEmail')) {
            gContext.toggleSignUpModal();
        }

        if (user == null && localStorage.getItem('userEmail') && (pathName.trim().toLowerCase() == "/signupcode" || pathName.trim().toLowerCase() == "/signupcode_expert" || pathName.trim().toLowerCase() == "/signupcode_client")) {
            gContext.toggleSignUpModal();
        }
        else if (pathName.trim().toLowerCase() == "/signupcode") {
            window.location.href = "/";
        }
        if (window.location.href.split('#').length > 1)
            window.location.href = window.location.href.replace(window.location.origin, "");

        const passwordChanged = localStorage.getItem('passwordChanged');
        if (passwordChanged) {
            localStorage.removeItem('passwordChanged');
            gContext.toggleSuccessModal();
        }
        getHomeFeatureData();

    }, [])

    return (
        <>
            <Header/>
                <div className="page-wrapper">

                    <section className="section welcome-sec bg-gray p-relative gradient-img bg-gray">
                        <div className="left-sec bg-gray text-center p-10 ">
                            <div className="section-title  m-10 p-10 text-center  "  >

                                <h1> Hire Top <span className="text-theme">Compliance Experts</span> in Days, Not Months</h1>
                                <p className="section-desc p-10  p-l-50 p-r-50 ">Connect with pre-vetted ISO, cybersecurity, FDA, and CMMI specialists ready to step in.<br/> Save 30-50% vs. traditional firms and pay nothing until you hire.</p>
                            <div className="d-grid w-full   p-20  text-center "  >    <button className="btn btn-green btn-block  w-250 m-auto pointer p-t-15 p-b-15 f-20" type="button" onClick={() => { window.open(process.env.REACT_APP_ONCEHUB, "_blank"); }}>Book a Call</button>
                                </div>

                            </div>


                        </div>

                        <div className="right-sec">
                            <div className="img-wrapper">
                                <img className="img-block" src="images/find-compliance.jpg" alt="image" />
                            </div>
                        </div>
                    </section>

                    <><div className="section how-it-works p-b-80 p-relative bg-gray">
                        <span className="bg-wrap"></span>
                        <div className="container">

                            <div className="section-title m-b-20">
                                <h2>Specialized <span className="text-theme">Experts </span> Available</h2>
                            </div>

                            <div className="expert-group-wrapper m-t-20 w-full">
                                <div className="tab-content">


                                    <div id="experts" className={`tab-pane active show `} role="tabpanel">
                                        <div className="step-wrapper">

                                            <div className="card step-block p-relative ">
                                                <img src="images/iso1.png" alt="create-profile" />
                                                    <h6>Consultants</h6>

                                               
                                            </div>
                                            <div className="card step-block p-relative">
                                                <img src="images/training.jpg" alt="post-requ" />
                                                    <h6>Trainers</h6>

                                              
                                            </div>

                                            <div className="card step-block p-relative">
                                                   <img src="images/get-hiried.svg" alt="get-hiried" />
                                                    <h6 className="w-full">Certification/Appraisal Body</h6>

                                                
                                            </div>
                                            <div className="card step-block p-relative">
                                                  <img src="images/compliance.png" alt="get-hiried" />
                                                    <h6>Auditors</h6>

                                                
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    </>
                    <section className="section ideal-group p-relative p-t-50 ">


                        <div className="frame-content-block ">
                            <div className="section-title">

                                <h2 className="p-b-5">Why <span className="text-theme">Syncuppro</span>?</h2>
                            </div>

                            <div className="frame-block">
                                <img src="images/compliance-experts-profiles.svg" alt="compliance-experts-profiles" />
                                <div className="frame-data">
                                    <h6>Hire in Days, Not Months:</h6>
                                    <p className="m-0">Fill critical compliance roles within days instead of waiting months for a traditional consulting firm. </p>
                                </div>
                            </div>

                            <div className="frame-block">
                                <img src="images/multiple-proposal.svg" alt="multiple-proposal" />
                                <div className="frame-data">
                                    <h6>Pre-Vetted Specialists:</h6>
                                    <p className="m-0">Access a network of rigorously vetted experts with proven credentials in ISO, FDA, InfoSec, CMMI, and more - only top talent makes the cut.</p>
                                </div>
                            </div>

                            <div className="frame-block">

                                <span className="text-theme m-icon material-icons m-r-15 font-72 font-weight-semibold   ">paid</span>
                                <div className="frame-data">
                                    <h6>Pay Only When You Hire:</h6>
                                    <p className="m-0">No upfront fees or retainers. It's risk-free - you only pay when you've successfully hired the right expert for your team.</p>
                                </div>
                            </div>

                            <div className="frame-block">
                                <img src="images/percentage-percent.svg" style={{ width: "64px" }} alt="percentage-percent" />

                                <div className="frame-data">
                                    <h6>30-50% Cost Savings:</h6>
                                    <p className="m-0">Transparent pricing with<b> 30-50% lower cost</b> than traditional consultancies or recruiters. Get expert help without breaking the budget. </p>
                                </div>
                            </div>

                            <div className="frame-block">
                                <img src="images/project-tracking.svg" alt="project-tracking" />
                                <div className="frame-data">
                                    <h6>Avoid Compliance Pitfalls:</h6>
                                    <p className="m-0">Don't let compliance issues derail your business. 41% of companies say lacking compliance readiness slows down sales <b><a href="https://www.brightdefense.com/resources/cybersecurity-compliance-statistics/#:~:text=65.%2041,%28Security%20Magazine" className="pointer" target="_blank">brightdefense.com</a></b> - and a failed audit can cost you million-dollar deals <b><a href="https://nonasec.com/resources/security-audit-failure-cost" target="_blank" className="pointer">nonasec.com</a></b>. Syncuppro helps you avert delays, audit failures, and lost deals by providing the right expert at the right time. </p>
                                </div>
                            </div>


                        </div>

                    <div className="m-auto  w-resp-half ">   <div className=" m-r-20 m-l-20  text-center  m-b-30 section-title">
                        <h5 className="text-center pointer" onClick={() => { window.open(process.env.REACT_APP_ONCEHUB, "_blank") }}><span className="text-green">Free 30-Minute </span>  Compliance Hiring Strategy Call </h5>
                        <h3 className=" text-center pointer" onClick={() => { window.open(process.env.REACT_APP_ONCEHUB, "_blank") }}>Plan your next hire with  <span className="text-theme"> expert </span> insight - in just one call</h3>
                        <p> Get role clarity, real-time market benchmarks, and a shortlist gameplan - all before the session ends.</p>
                    </div> <div className="m-auto m-b-50  m-t-40 pointer  card p-0 calender-width" data-toggle="tooltip" title="Click to Book a call" onClick={() => { window.open(process.env.REACT_APP_ONCEHUB, "_blank") }}> <Calendar /></div>
                        <div className=" m-r-20 m-l-20   m-b-30 section-title">  <h6>  What you get on the call:</h6>
                            <ul className="policy-list m-t-10 m-l-10">
                                <li className="m-b-5">
                                    
                                    <span>
                                        <b> <span className="m-icon material-icons f-11 m-r-10">circle</span>Define the role </b> - scope, budget, timeline, and hiring goals
                                    </span>
                                </li>
                                <li className="m-b-5">
                                    
                                    <span>
                                        <b><span className="m-icon material-icons f-11 m-r-10">circle</span>See live data</b>  - current day rates & time-to-hire for similar roles
                                    </span>
                                </li>
                                <li className="m-b-5">
                                    
                                    <span>
                                        <b> <span className="m-icon material-icons f-11 m-r-10">circle</span>Walk away ready</b>  - we send you 5 vetted expert profiles within 24 hours
                                    </span>
                                </li> 
                            </ul>
                        </div> 
                    </div>
                   </section>

            </div>
            <Footer/>
          
        </>
    );
};

